<script setup lang="ts">
import type { EverFormModel } from "@/types";
import { useDateFormat } from "@vueuse/core";
defineProps({
  modelValue: {
    type: Object as PropType<EverFormModel>,
    required: true,
  },
});

const emit = defineEmits(["unmount"]);

onBeforeUnmount(() => {
  emit("unmount");
});
</script>

<template>
  <h1>Your request has been submitted!</h1>

  <p>
    In the coming weeks, we will share more about hosting celebrations of love at EVER and the
    opening of One Times Square.
  </p>

  <div class="summary-block">
    <div class="header">Summary</div>

    <div class="content">
      <ul>
        <li>
          Event: <b>{{ modelValue.eventType }}</b>
        </li>

        <li v-for="(date, index) in modelValue.dates" :key="date.date">
          Date {{ index + 1 }}:
          <b>{{ useDateFormat(date.date, "MMMM DD, YYYY") }} - {{ date.time }}</b>
        </li>
        <li>
          Number of guests: <b>{{ modelValue.numberGuests }}</b>
        </li>
      </ul>

      <ul>
        <li>
          First Name: <b>{{ modelValue.firstname }}</b>
        </li>
        <li>
          Last Name: <b>{{ modelValue.lastname }}</b>
        </li>
        <li>
          Email: <br class="mobile-break" /><b>{{ modelValue.email }}</b>
        </li>
        <li>
          Country: <b>{{ modelValue.country }}</b>
        </li>
        <li>
          Telephone Number: <br class="mobile-break" /><b>{{ modelValue.phone }}</b>
        </li>
        <li><br /></li>
        <li>
          First Partner Full Name: <br class="mobile-break" /><b>{{
            modelValue.firstPartnerName
          }}</b>
        </li>
        <li>
          Second Partner Full Name: <br class="mobile-break" /><b>{{
            modelValue.secondPartnerName
          }}</b>
        </li>
      </ul>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use "@/assets/scss/queries";
.summary-block {
  box-shadow: 0px 4px 17.7px 8px #00000040;
  width: 100%;

  .header {
    background-color: black;
    color: white;
    font-size: 2rem;
    font-weight: 700;
    padding: 1rem 6rem;
    text-align: left;

    @include queries.for-size(phone-only) {
      font-size: 20px;
      text-align: center;
    }
  }

  .content {
    display: flex;
    gap: 8rem;
    padding: 4rem 6rem;
    width: 100%;

    @include queries.for-size(ipadpro-portrait-down) {
      flex-direction: column;
      gap: 2rem;
    }

    @include queries.for-size(phone-only) {
      padding: 4rem 2rem;
    }

    ul {
      list-style-type: none;
      margin: 0;
      padding: 0;
    }
  }
}

.sub-text {
  margin: 0 auto !important;
  text-align: center;
  width: 80%;
}
</style>
